import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-text-filter-header',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-text-filter-header',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TextFilterHeaderComponent {}
